var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.84 83.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc962;}.cls-2{fill:none;stroke:#ffc962;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3,.cls-4{fill:#8cd3d5;}.cls-4{opacity:0.18;}.cls-5,.cls-6{font-size:48.98px;font-family:Swiss721BT-Heavy, Swis721 Hv BT;font-weight:800;}.cls-5{fill:#20b0c6;}.cls-6{fill:#f26f64;}.cls-7{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.23,
    y1: 0.81,
    x2: 24.5,
    y2: 14.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0085b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20b0c6"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 19logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 58.05,
    cy: 32.13,
    r: 3.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.07,
    y1: 71.61,
    x2: 17.34,
    y2: 44.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.7,
    y1: 32.49,
    x2: 41.15,
    y2: 23.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.25,70.56,45.15,58.62,44,58.45l-4.32-8L43.86,42l8.89-.87,5.14-8.68-.19,8.94L62.43,48l-6.09,6.87L55.08,70.75S66.7,57.24,75.64,45.66s5.85-23.54-5.44-29.4c-.6-.32-.44-.23-.66-.34a14.5,14.5,0,0,0-14.17.15,4,4,0,0,0-1.73,5.41l4.47,10.58,16.45,14.6-5.4-30.45L58.71,31.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.41,76.5l4.75,5.13a1,1,0,0,0,1.46,0l4.9-5.13a1,1,0,0,0-.72-1.7H41.15A1,1,0,0,0,40.41,76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.65,14.42,18.91.49,11.35,15.1,1,15.36A.56.56,0,0,1,.65,14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,7.32,18.91.49,40.56,0A.76.76,0,0,1,41,1.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.91 0.97 23.58 14.68 11.66 15.04 18.91 0.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.75 7.53 19.18 0.87 23.77 14.62 32.75 7.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12.19 15.31 14.49 21.94 26.02 21.66 12.19 15.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.3 7.48 26.54 21.37 35.7 14.19 33.3 7.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.83 14.85 26.2 21.5 32.85 7.81 23.83 14.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12.49 15.21 23.63 14.94 25.95 21.46 12.49 15.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "7.16 15.56 4.18 29.86 3.44 15.63 7.16 15.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3.86 23.69 4.18 29.86 5.5 23.92 3.86 23.69"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(9.96 49.45)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(33.06 72.35)"
  }, "P"), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.91 0.49 0 15.04 23.58 14.68 42.72 0 18.91 0.49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.5edcff22f8b98b87816a37c11dbbdb63.svg";
export { ForwardRef as ReactComponent };